<template>
    <section id="reviews" class="reviews section">
        <div class="container_big">
            <div class="reviews__title">
                <app-title>ОТЗЫВЫ</app-title>
            </div>
            <div class="reviews__inner">
                <div class="reviews__slider">
                    <swiper ref="slider" :options="swiperOptions">
                        <swiper-slide v-for="(review) in 8" :key="review">
                            <div class="reviews__slide-img">
                                <img :src="require(`@/assets/img/reviews/rev${review}.png`)" alt="Review">
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="reviews__slider-prev">
                        <svg width="26" height="52" viewBox="0 0 26 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="path-1-inside-1_722_639" fill="white">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M25.3311 0.0136566C25.3311 0.0136414 25.3311 0.0136223 25.331 0.0136108C25.331 0.013588 25.331 0.013588 25.331 0.0136108L2.1662 23.1784C0.6041 24.7405 0.604096 27.2731 2.16619 28.8352L25.331 52C25.331 52 25.331 52 25.331 52C25.331 52 25.3311 52 25.3311 51.9999L25.3311 0.0136566Z"/>
                            </mask>
                            <path
                                d="M2.16619 28.8352L0.75198 30.2494L2.16619 28.8352ZM25.331 0.0136108L26.7452 1.42783L25.331 0.0136108ZM3.58041 24.5926L26.7452 1.42783L23.9167 -1.4006L0.751982 21.7642L3.58041 24.5926ZM26.7452 50.5858L3.58041 27.421L0.75198 30.2494L23.9167 53.4142L26.7452 50.5858ZM27.3311 51.9999L27.3311 0.0136568L23.3311 0.0136564L23.3311 51.9999L27.3311 51.9999ZM26.7453 53.4142C27.1203 53.0391 27.3311 52.5304 27.3311 51.9999L23.3311 51.9999C23.3311 51.4695 23.5418 50.9608 23.9168 50.5858L26.7453 53.4142ZM23.9167 53.4142C24.6978 54.1953 25.9642 54.1953 26.7453 53.4142L23.9168 50.5858C24.6978 49.8047 25.9641 49.8047 26.7452 50.5858L23.9167 53.4142ZM0.751982 21.7642C-1.59116 24.1073 -1.59117 27.9063 0.75198 30.2494L3.58041 27.421C2.79936 26.64 2.79936 25.3736 3.58041 24.5926L0.751982 21.7642ZM23.9168 1.42783C23.6828 1.19377 23.5432 0.938919 23.4618 0.724762C23.3794 0.508415 23.3311 0.267937 23.3311 0.0136564L27.3311 0.0136568C27.3311 -0.429611 27.1778 -0.968067 26.7453 -1.4006L23.9168 1.42783ZM26.7453 -1.4006C25.9547 -2.19112 24.6883 -2.1722 23.9167 -1.4006L26.7452 1.42783C25.9736 2.19937 24.7073 2.2183 23.9168 1.42783L26.7453 -1.4006Z"
                                fill="#B6B6B6" mask="url(#path-1-inside-1_722_639)"/>
                        </svg>
                    </div>
                    <div class="reviews__slider-next">
                        <svg width="26" height="52" viewBox="0 0 26 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="path-1-inside-1_725_1723" fill="white">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M0.675781 51.9864C0.675781 51.9864 0.675784 51.9864 0.675789 51.9864C0.675799 51.9864 0.675816 51.9864 0.675827 51.9864L23.8406 28.8216C25.4027 27.2595 25.4027 24.7269 23.8406 23.1648L0.675827 7.8211e-06C0.675816 -2.60703e-06 0.675799 -2.60703e-06 0.675789 7.82109e-06C0.675784 1.28289e-05 0.675781 1.96208e-05 0.675781 2.67029e-05V51.9864Z"/>
                            </mask>
                            <path
                                d="M0.675827 7.8211e-06L2.09004 -1.41421L0.675827 7.8211e-06ZM0.675827 51.9864L2.09004 53.4006L0.675827 51.9864ZM22.4264 27.4074L-0.738387 50.5722L2.09004 53.4006L25.2548 30.2359L22.4264 27.4074ZM-0.738387 1.41422L22.4264 24.579L25.2548 21.7506L2.09004 -1.41421L-0.738387 1.41422ZM-1.32422 2.67029e-05V51.9864H2.67578V2.67029e-05H-1.32422ZM-0.738425 -1.41421C-1.1135 -1.03913 -1.32422 -0.530413 -1.32422 2.67029e-05H2.67578C2.67578 0.530453 2.46507 1.03915 2.09 1.41422L-0.738425 -1.41421ZM2.09004 -1.41421C1.30898 -2.19526 0.0426348 -2.19527 -0.738425 -1.41421L2.09 1.41422C1.30896 2.19526 0.0426512 2.19526 -0.738387 1.41422L2.09004 -1.41421ZM25.2548 30.2359C27.598 27.8927 27.598 24.0937 25.2548 21.7506L22.4264 24.579C23.2074 25.3601 23.2074 26.6264 22.4264 27.4074L25.2548 30.2359ZM2.09 50.5722C2.33135 50.8136 2.46977 51.0745 2.5483 51.2838C2.62808 51.4964 2.67578 51.7339 2.67578 51.9864H-1.32422C-1.32422 52.4155 -1.17953 52.9595 -0.738425 53.4006L2.09 50.5722ZM-0.738425 53.4006C0.0138907 54.153 1.28054 54.2101 2.09004 53.4006L-0.738387 50.5722C0.0710884 49.7627 1.33771 49.8199 2.09 50.5722L-0.738425 53.4006Z"
                                fill="#534340" fill-opacity="0.3" mask="url(#path-1-inside-1_725_1723)"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {Navigation, Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'
import MainContacts from "@/components/mainPage/MainContacts";

export default {
    components: {MainContacts, Swiper, SwiperSlide},
    name: "ReviewsVue",
    data() {
        return {
            swiperOptions: {
                modules: [Navigation],
                navigation: {
                    prevEl: '.reviews__slider-prev',
                    nextEl: '.reviews__slider-next'
                },
                spaceBetween: 10,
                loop: true,
                breakpoints: {
                    1920: {
                        spaceBetween: 40,
                        slidesPerView: 3
                    },
                    1440: {
                        spaceBetween: 20,
                        slidesPerView: 3
                    },
                    1024: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    768: {
                        spaceBetween: 14,
                        slidesPerView: 'auto'
                    },
                    480: {
                        slidesPerView: 'auto',
                        spaceBetween: 16
                    }
                }
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.reviews {
    text-align: center;

    &__title {
        display: inline-block;
        margin-top: -30px;
    }

    &__inner {
        border: 1.5px solid #CDCDCD;
        border-radius: 40px;
        margin-top: -55px;
        padding: 134px 227px 234px;
        @media (max-width: 1919px) {
            padding: 107px 88px 261px;
        }
        @media (max-width: 1439px) {
            border: none;
            padding: 100px 46px 270px;
        }
        @media (max-width: 767px) {
            padding: 100px 0 220px;
        }
    }

    &__slide-img {
        border-radius: 20px;

        & img {
            border-radius: 20px;
        }
    }

    &__slider {
        position: relative;

        &-prev {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translate(calc(-100% - 30px), -50%);
            cursor: pointer;
            @media (max-width: 767px) {
                display: none;
            }
        }

        &-next {
            position: absolute;
            right: 0;
            top: 50%;
            cursor: pointer;
            transform: translate(calc(100% + 30px), -50%);
            @media (max-width: 767px) {
                display: none;
            }
        }
    }
}
</style>